<template>
  <div class="Assets">
    <HeaderReturn title="资产"></HeaderReturn>
    <div class="property">
      <!-- <img src="" alt=""> -->
      <div class="assets_img_box">
        <div class="assets_img">
          <img src="../../assets/img/tabar/examine.png" alt="" />
        </div>
        <p>总 资 产 折 合（USDT）</p>
      </div>

      <p class="d-flex my_asset">
        <Tests
          v-if="MoneyList != 0"
          :time="2"
          :value="MoneyList"
          class="numsp"
        ></Tests>
      
        <span v-else>0</span>
        <span class="assets_tip">您的账户余额</span>
      </p>
    </div>
    <div class="Assets_grid">
      <ul>
        <li v-for="item in TeamList" :key="item.id" @click="goLink(item.path)">
          <img :src="item.url" />
          <p class="fn-13">{{ item.txt }}</p>
        </li>
      </ul>
    </div>
    <div class="Assets_ul">
      <ul>
        <li
          v-for="(item, index) in AccasetList"
          :key="item.id"
          @click="goLink('/My/details', item)"
          class="my_flex"
        >
          <div>
            <!-- <div class="flex_img"></div> -->
            <!-- <p>
              {{ item.ycoinName }}
            </p> -->
            <img
              v-if="item.ycoinName != 'LQD' && item.ycoinName != 'USDT2'&&item.ycoinName != 'LQD1'"
              :src="
                'https://qhzx-kline2.oss-ap-southeast-1.aliyuncs.com/logos/' +
                item.ycoinName +
                '.png'
              "
              alt=""
              class="img"
            />
            <img
              v-else
              src="../../assets/img/page/LQD.png"
              alt=""
              class="img"
            />
            <span>{{ item.ycoinName }}</span>
          </div>

          <div class="box_flex">
            <p>{{ item.usableBalance }}</p>
            <p>可用余额</p>
          </div>
          <div class="box_flex">
            <p>{{ item.freezeBalance }}</p>
            <p>冻结</p>
          </div>
          <div>
            <p>
              <!-- <van-icon name="arrow" /> -->
              <img src="../../assets/img/page/JT-45X27.png" alt="" />
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { NoticeBar, Icon } from "vant";
Vue.use(NoticeBar).use(Icon);
import vueQr from "vue-qr";
import { mainApiData } from "@/request/api.js";
export default {
  components: {
    vueQr,
  },
  data() {
    return {
      baseApi: "",
      Aeccter: {
        money: 75.8193,
      },
      TeamList: [
        {
          url: require("../../assets/img/page/CB-22.png"),
          txt: "充值",
          id: 0,
          path: "/My/recharge",
        },
        {
          url: require("../../assets/img/page/TB-22.png"),
          txt: "提币",
          id: 1,
          path: "/My/withdrawal",
        },
        {
          url: require("../../assets/img/page/SD-22.png"),
          txt: "闪兑",
          id: 2,
          path: "/My/flashExchange",
        },
      ],
      AccasetList: [],
      MoneyList: 0,
    };
  },
  created() {
    this.baseApi = process.env.VUE_APP_IMG;

    this.Init();
  },
  methods: {
    Init() {
      mainApiData.getUserAllAssets().then((res) => {
        this.AccasetList = res.data.data;
      });
      mainApiData.getUserEquivalent().then((res) => {
        if (res.data.code == 200) {
          this.MoneyList = res.data.data.USDT;
        }
      });
    },
    onCopy() {
      this.$toast(this.$t("myself.a23"));
    },
    goLink(path, item) {
      if (path) {
        this.$router.push({
          path,
          query: {
            item: JSON.stringify(item),
          },
        });
      } else {
        // 暂未开放
        this.$toast(this.$t("orePond.a42"));
      }
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";

::v-deep .box_flex {
  display: flex;
  flex-direction: column;
  align-items: center;
}
::v-deep .my_flex {
  display: grid;
  grid-template-columns: 15% 35% 35% 15%;

  // flex-direction: column !important;
  align-items: center;
  // justify-content: space-between;
}
::v-deep .assets_tip {
  color: #19ebff !important;
  font-size: 12px !important;
  margin-top: 25px;
}
::v-deep .number-grow{
    color: #915E20 !important;
  }
::v-deep .my_asset {
  padding-top: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 25px;
  
  font-size: 40px !important;

}
.Assets {
  margin: 50px 10px;

  ::v-deep .van-nav-bar__title {
    color: #f89b19;
    font-size: 20px;
    font-weight: 600;
  }

  .property {
    margin: 15px 5px;
    padding: 15px 0 18px 0;

    background: url(../../assets/img/page/ZC-345X180.png) no-repeat;
    background-size: 100% 100%;

    ::v-deep .number-grow {
      color: #915E20 !important;
      font-size: 30px;
    }
  
    .assets_img_box {
      display: flex;
      //   border: solid 1px red;
      padding-left: 20px;
      padding-top: 10px;
      color: #915E20 !important;
      .assets_img {
        // background-color: linear-gradient(to right, rgba(10, 111, 168, 1), rgba(2, 90, 118, 1));
        // background-color: red;
        // border-radius: 50%;
        img {
          width: 29px;
          height: 29px;
        }
      }
    }

    ::v-deep .number-grows {
      color: #915E20 !important;
      font-size: 16px;
      margin-top: 3px;
      display: block;
    }

    p {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */

      /* 白/FE */

      color: #915E20 !important;

      &:nth-child(1) {
        padding: 20px 10px 0 10px;

      
      }
      ::v-deep .numsp {

color: #915E20 !important;
}
      span {
        color: #915E20 !important;
        font-size: 18px;
      }

      &:nth-child(2) {
        padding: 5px 10px 0 10px;
      }

      .numsp {
        font-size: 30px !important;
        color: #915E20 !important;
        // border: 1px solid red;
      }
    }
  }

  .Assets_grid {
    padding: 0 3px;
    ul {
      display: flex;
      justify-content: space-between;
      //   grid-template-columns: 25% 25% 25% 25%;
      text-align: center;

      li {
        // flex: 1;
        width: 28%;
        margin-top: 17px;
        border-radius: 14px;
        opacity: 0.8999999761581421;
        background: var(--unnamed, #f89b19);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px 20px;
        img {
          // margin: 10px 0;
          width: 22px;
          height: 22px;
        }

        p {
          // padding: 8.74px 0px 15px 0;
          color: #fff;
          font-size: 12px;
          margin-left: 5px;
        }
      }

      // align-items: center;
    }
  }

  .Assets_ul {
    // border: 1px solid red;
    overflow: hidden;
    overflow-y: scroll;
    height: 530px;

    ul {
      li {
        margin: 15px 5px;
        padding: 15px 19px;
        // background: rgba(20, 132, 195, 0.2);
        /* 黄/主题 */
        border-radius: 10px;
        // border: 0.5px solid #1484c4;
        border: 1px solid #f89b19;
 
        div {
          &:nth-child(1) {
            // padding: 10px 15px;
            // width: 40px;
            // height: 40px;
            // background-color: #fff;
            // border-radius: 5px;
            display: flex;
            align-items: center;
            flex-direction: column;

            img {
              width: 40px;
              height: 40px;
              margin-bottom: 5px;
            }
            p {
              font-style: normal;
              font-weight: 400;
              font-size: 12px;
              line-height: 25px;
              text-align: center;

              color: #ffffff;

              &:nth-child(1) {
                font-family: "PingFang SC";
                font-style: normal;
                font-weight: 400;
                font-size: 18px;
                line-height: 25px;
                text-align: center;

                color: #ffffff;
              }
            }
          }

          &:nth-child(2),
          &:nth-child(3) {
            // display: grid;
            // justify-content: space-between;
            // grid-template-columns: 50% 50%;
            // border: 1px solid red;
            padding: 0px 15px;
            p {
              font-family: "PingFang SC";
              font-style: normal;
              font-weight: 400;
              width: 100%;
              line-height: 22px;
              color: #fefefe !important;
              font-size: 14px;
              &:last-child {
                color: #7b7b7b !important;
                font-size: 12px;
              }
            }
          }
          &:nth-child(4) {
            text-align: right;
            img {
              width: 50px;
              height: 30px;
            }
          }
        }
      }
    }
  }
}
</style>
